export default "__VITE_ASSET__acb57d56__"